import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },

  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
  },
  {
    path: 'members',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/users/users.page').then((m) => m.UsersPage),
  },

  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
  },
  {
    path: 'transactions',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/transactions/transactions.page').then(
        (m) => m.TransactionsPage
      ),
  },
  {
    path: 'transactions/transfers',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/transactions/transfers/transfers.component').then(
        (m) => m.TransfersComponent
      ),
  },
  {
    path: 'transactions/payouts',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/transactions/payouts/payouts.component').then(
        (m) => m.PayoutsComponent
      ),
  },

  {
    path: 'virtual-accounts',
    loadComponent: () =>
      import('./pages/virtual-accounts/virtual-accounts.page').then(
        (m) => m.VirtualAccountsPage
      ),
  },

  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];
